module.exports = __webpack_public_path__ + "static/share-37762a2343b4a3e589b78edc803a1d18.png";